import { Button, Header, LoadingSpinner } from '@components/Generic'
import { cx } from '@/utils/cx'

// The screens the GoCardless pages after the bank share: while they load, while the session is handed
// on by a full navigation, and when loading failed. `className` adds to the page container (the
// screens of the session's pauses are `w-500 p-40`, the return page is not).

interface ScreenProps {
  className?: string
}

export const GocardlessLoadingScreen = ({ className }: ScreenProps) => (
  <div className={cx('page-container mobile-m-10', className)}>
    <LoadingSpinner />
  </div>
)

interface RedirectingScreenProps extends ScreenProps {
  header?: string
  label?: string
  buttonLabel?: string
}

/** shown while the browser leaves for the backend (or the next screen); nothing can be done here */
export const GocardlessRedirectingScreen = ({
  header,
  label,
  buttonLabel,
  className,
}: RedirectingScreenProps) => (
  <div className={cx('page-container mobile-m-0', className)}>
    <Header>{header}</Header>

    <p className="generic__paragraph-centered">{label}</p>

    <LoadingSpinner className="loading-spinner--small-padding" />

    <div className="layout__content-container-bottom-centered">
      <Button disabled className="button--w164">
        {buttonLabel}
      </Button>
    </div>
  </div>
)

interface LoadErrorScreenProps extends ScreenProps {
  header?: string
  message?: string
  retryLabel?: string
  retryTestId?: string
  onRetry: () => void
}

export const GocardlessLoadErrorScreen = ({
  header,
  message,
  retryLabel,
  retryTestId,
  onRetry,
  className,
}: LoadErrorScreenProps) => (
  <div className={cx('page-container mobile-m-0', className)}>
    <Header>{header}</Header>

    <p className="generic__paragraph-centered generic__error-message" role="alert">
      {message}
    </p>

    <div className="layout__content-container-bottom-centered">
      <Button onClick={onRetry} className="button--w164" dataTestid={retryTestId}>
        {retryLabel}
      </Button>
    </div>
  </div>
)
